import './disable-on-submit';



// WEBPACK FOOTER //
// ./project/client/src/core/components/index.js